exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".m-btn[data-v-68b37ad3],.m-btn[data-v-68b37ad3]:hover{font-size:16px!important;color:#fff!important;background:#a28b77!important;opacity:.3}.pay-dialog-body[data-v-68b37ad3]{width:531px;height:90vh;background:#fff;border-radius:8px;overflow:hidden}.pay-dialog-top[data-v-68b37ad3]{position:relative;display:block;width:100%;height:66px;background:#1677ff}.pay-dialog-top div[data-v-68b37ad3]{font-size:20px;font-weight:600;color:#fff;line-height:64px;text-align:center}.pay-dialog-top img[data-v-68b37ad3]{position:absolute;width:18px;height:18px;top:16px;right:20px;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-68b37ad3","scoped":true,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/pages/agent/go-pay.vue
// module id = 476
// module chunks = 1